function normalizeProfileRouteOverrideMap(payload = {}) {
  if (payload?.overrideMap && typeof payload.overrideMap === 'object' && !Array.isArray(payload.overrideMap)) {
    return payload.overrideMap;
  }

  if (Array.isArray(payload?.overrides)) {
    return payload.overrides.reduce((accumulator, override) => {
      const policyId = typeof override?.policyId === 'string' ? override.policyId.trim() : '';
      const description = typeof override?.description === 'string' ? override.description.trim() : '';
      if (policyId && description) {
        accumulator[policyId] = description;
      }
      return accumulator;
    }, {});
  }

  if (payload?.overrides && typeof payload.overrides === 'object' && !Array.isArray(payload.overrides)) {
    return payload.overrides;
  }

  return {};
}

function normalizeProfileRouteTitleOverrideMap(payload = {}) {
  if (payload?.titleOverrideMap && typeof payload.titleOverrideMap === 'object' && !Array.isArray(payload.titleOverrideMap)) {
    return payload.titleOverrideMap;
  }

  if (Array.isArray(payload?.overrides)) {
    return payload.overrides.reduce((accumulator, override) => {
      const policyId = typeof override?.policyId === 'string' ? override.policyId.trim() : '';
      const title = typeof override?.title === 'string' ? override.title.trim() : '';
      if (policyId && title) {
        accumulator[policyId] = title;
      }
      return accumulator;
    }, {});
  }

  return {};
}

function normalizeLocalizedProfileRouteOverrideMaps(payload = {}, mapKey = 'localizedOverrideMap', valueKey = 'localizedDescriptions') {
  if (payload?.[mapKey] && typeof payload[mapKey] === 'object' && !Array.isArray(payload[mapKey])) {
    return payload[mapKey];
  }

  if (Array.isArray(payload?.overrides)) {
    return payload.overrides.reduce((accumulator, override) => {
      const policyId = typeof override?.policyId === 'string' ? override.policyId.trim() : '';
      const localizedValues = override?.[valueKey];

      if (!policyId || !localizedValues || typeof localizedValues !== 'object' || Array.isArray(localizedValues)) {
        return accumulator;
      }

      Object.entries(localizedValues).forEach(([locale, value]) => {
        const normalizedLocale = typeof locale === 'string' ? locale.trim().toLowerCase() : '';
        const normalizedValue = typeof value === 'string' ? value.trim() : '';

        if (!normalizedLocale || !normalizedValue) {
          return;
        }

        if (!accumulator[normalizedLocale]) {
          accumulator[normalizedLocale] = {};
        }

        accumulator[normalizedLocale][policyId] = normalizedValue;
      });

      return accumulator;
    }, {});
  }

  return {};
}

function normalizeProfileRouteLocalizedDescriptionOverrideMap(payload = {}) {
  return normalizeLocalizedProfileRouteOverrideMaps(payload, 'localizedOverrideMap', 'localizedDescriptions');
}

function normalizeProfileRouteLocalizedTitleOverrideMap(payload = {}) {
  return normalizeLocalizedProfileRouteOverrideMaps(payload, 'localizedTitleOverrideMap', 'localizedTitles');
}

module.exports = {
  normalizeProfileRouteOverrideMap,
  normalizeProfileRouteLocalizedDescriptionOverrideMap,
  normalizeProfileRouteLocalizedTitleOverrideMap,
  normalizeProfileRouteTitleOverrideMap,
};
